import React, { useState } from 'react'
import Navbar from '../nav';
import { Link } from 'react-router-dom';

export default function LoginForm() {

    const [formData, setFormData] = useState({
        username: '',
        password: '',
      });
    
      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        // Add your login logic here
        console.log('Login logic goes here', formData);
      };

  return (
    <div>
        <Navbar />
    
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
   <div className="max-w-md w-full space-y-8">
     <div>
       <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
         Log in to your account
       </h2>
     </div>
     <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
       <div>
         <label htmlFor="email" className="sr-only">
           Email address
         </label>
         <input
           id="username"
           name="username"
           type="username"
           autoComplete="username"
           required
           className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900  focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
           placeholder="Email address"
           value={formData.username}
           onChange={handleChange}
         />
       </div>
       <div>
         <label htmlFor="password" className="sr-only">
           Password
         </label>
         <input
           id="password"
           name="password"
           type="password"
           autoComplete="current-password"
           required
           className="appearance-none  relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
           placeholder="Password"
           value={formData.password}
           onChange={handleChange}
         />
       </div>
       <div>
         <button
           type="submit"
           className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
         >
           Log in
         </button>
       </div>
     </form>
     <div className="text-center">
       <p className="text-sm text-gray-600">
         Don't have an account?{' '}
         <Link to="/signup" className="font-medium text-indigo-600 hover:text-indigo-500">
           Sign up
         </Link>
       </p>
     </div>
   </div>
 </div>
    </div>

  )
}
